
import { defineComponent } from 'vue';
import loader from '@monaco-editor/loader';
import { editor, IMouseEvent, Range, Selection } from 'monaco-editor';
import CodeBlockFolder from '../components/CodeBlockFolder.vue';
import CodeBlock from '../components/CodeBlock.vue';
import { useCodeViewStore } from '../store';

let editorRef: editor.IStandaloneCodeEditor | null = null;
let monacoRef: any | null = null;
export default defineComponent({
  name: 'CodeViewPage',
  components: { CodeBlockFolder, CodeBlock },
  data(): {
    store: any;
    openText: string;
    openMenu: boolean;
  } {
    return {
      store: useCodeViewStore(),
      openText: '',
      openMenu: false
    };
  },
  mounted() {
    loader.init().then((monaco): void => {
      const editorElem = document.getElementById('editor');
      if (editorElem) {
        editorRef = monaco.editor.create(editorElem, {
          language: 'python'
        });
      }
      monacoRef = monaco;
      let newModel = monacoRef.editor.createModel(defaultText, 'python');
      editorRef?.setModel(newModel);
    });
  },
  methods: {
    onMount() {
      const store = useCodeViewStore();
      loader.init().then((monaco): void => {
        const editorElem = document.getElementById('editor');
        if (editorElem) {
          editorRef = monaco.editor.create(editorElem, {
            language: 'python'
          });
        }
        monacoRef = monaco;
      });
    },
    onEditorDrop(e: DragEvent) {
      let cursorPos: editor.IMouseTarget = editorRef?.getTargetAtClientPoint(
        e.clientX,
        e.clientY
      )!;
      // insert function call
      let textToInsert: string = e.dataTransfer?.getData('codeBody') || '';
      let lineText: string =
        editorRef
          ?.getModel()
          ?.getLineContent(cursorPos.position?.lineNumber!) || '';
      if (lineText.trim() != '') {
        textToInsert = `\n${lineText.match(/^\s*/)}${textToInsert}`;
      } else if (lineText == '') {
        let prevLineText: string =
          editorRef
            ?.getModel()
            ?.getLineContent(cursorPos.position?.lineNumber! - 1) || '';
        textToInsert = `${prevLineText.match(/^\s*/)}${textToInsert}`;
      }
      insertTextAtPos(
        editorRef!,
        textToInsert,
        [cursorPos.position?.lineNumber!, lineText.length + 1],
        true
      );

      // insert function definition
      let functionDefinition: string = e.dataTransfer?.getData('codeDef') || '';
      let definitionMatches: editor.FindMatch[] | undefined = editorRef
        ?.getModel()
        ?.findMatches(functionDefinition, false, false, true, null, true);
      if (!definitionMatches || definitionMatches.length == 0) {
        functionDefinition = `\n${functionDefinition}`;
        insertTextAtPos(
          editorRef!,
          functionDefinition,
          [editorRef?.getModel()?.getLineCount() || 0, 0],
          true
        );
      }
    }
  }
});

const insertTextAtPos = (
  instance: editor.IStandaloneCodeEditor,
  text: string,
  coords: [number, number] = [0, 0],
  placeCursor: boolean = false
) => {
  const range = new Range(coords[0], coords[1], coords[0], coords[1]);
  if (placeCursor) {
    console.log(`editing ${text}`);
    const selection = new Selection(coords[0], coords[1], coords[0], coords[1]);
    instance.executeEdits(
      'insert',
      [{ forceMoveMarkers: true, range: range, text: text }],
      [selection]
    );
    instance.focus();
  } else {
    instance.executeEdits('insert', [{ range, text, forceMoveMarkers: true }]);
  }
  instance.pushUndoStop();
};

const onDrop = (
  e: DragEvent,
  target: IMouseEvent,
  instance: editor.IStandaloneCodeEditor
) => {
  console.log('dropping');
  const text = e.dataTransfer?.getData('text');
  if (text && instance) {
    insertTextAtPos(instance, text, [target.posx, target.posy], true);
  }
};

const defaultText = `import rclpy
from rclpy.node import Node

from std_msgs.msg import String


class MinimalPublisher(Node):

    def __init__(self):
        super().__init__('minimal_publisher')
        self.publisher_ = self.create_publisher(String, 'topic', 10)
        timer_period = 0.5  # seconds
        self.timer = self.create_timer(timer_period, self.timer_callback)
        self.i = 0

    def timer_callback(self):
        msg = String()
        msg.data = 'Hello World: %d' % self.i
        self.publisher_.publish(msg)
        self.get_logger().info('Publishing: "%s"' % msg.data)
        self.i += 1


def main(args=None):
    rclpy.init(args=args)

    minimal_publisher = MinimalPublisher()

    rclpy.spin(minimal_publisher)

    # Destroy the node explicitly
    # (optional - otherwise it will be done automatically
    # when the garbage collector destroys the node object)
    minimal_publisher.destroy_node()
    rclpy.shutdown()


if __name__ == '__main__':
    main()
`;
